import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.course_lessons_index> = {
  queryKey: 'courseLessons',
  query: QUERY,
}

export default List
